import { render, staticRenderFns } from "./HeaderSettings.vue?vue&type=template&id=0a9a8904"
import script from "./HeaderSettings.vue?vue&type=script&lang=js"
export * from "./HeaderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports